import api from "./api";
import { ENV } from "../utils/constants";

export const listStores = async (): Promise<any> => {
  try {
    const { data } = await api.get(
      `pedido-p1-${ENV}/${ENV}/crm/getLojas`
    );
    return data;
  } catch (err) {
    return err;
  }
};

export const createStore = async (store: any): Promise<any> => {
  try {
    const { data } = await api.post(
      `pedido-p1-${ENV}/${ENV}/crm/postLoja`,
      store
    );

    return data;
  } catch (err) {
    return err;
  }
};

export const deleteStore = async (store: any): Promise<any> => {
  try {
    const { data } = await api.put(
      `pedido-p1-${ENV}/${ENV}/crm/disableLoja`,
      store
    );

    return data;
  } catch (err) {
    return err;
  }
};

export const updateStore = async (store: any): Promise<any> => {
  try {
    const { data } = await api.put(
      `pedido-p1-${ENV}/${ENV}/crm/putLojas`,
      store
    );

    return data;
  } catch (err) {
    return err;
  }
};

export const createStoreLogo = async (imageBase64: any): Promise<any> => {
  try {
    const { data } = await api.post(
      `lista-ofertas-p1-${ENV}/postProdutoImagem`,
      imageBase64
    );

    return data;
  } catch (err) {
    return err;
  }
};
